import React, { Component } from 'react';
import './Component.css';
import OriginArea from './OriginArea/OriginArea.jsx';
import './Intro.css';
import * as d3 from 'd3';
import ReadMore from './ReadMore/ReadMore.jsx';
import { getText } from './AllTexts.jsx';

const continents = ["Oceania", "Europe", "Asia", "Americas", "Africa"];

class Legend extends Component {
	render() {
		let rendered = continents.map((continent,i) =>
			<div class="item">
				<div
					class="square"
					style={{backgroundColor: d3.interpolateViridis(i/6)}}
				></div>
				<div class="label">
					{continent}
				</div>
			</div>
		);

		return <div class="legend"><div class="item">Permanent immigrant arrivals from:</div>{rendered}</div>
	}
}

class Intro extends Component {
	render() {
		let margin = 20;
		if (this.props.width < 1000) {
			margin = 10;
		}

		if (this.props.width < 800) {
			margin = 0;
		}
		return (
		<div className="Component" id="intro">
			{ getText('intro-beginning') }

			<div className="metropolis-video">
				<iframe src="https://player.vimeo.com/video/311667162?title=0&byline=0&portrait=0" width="640" height="360" frameBorder="0" allowFullScreen></iframe>
				<p>Keynote Lecture, 2018 International Metropolis Conference, Sydney</p>
			</div>

			{ getText('intro-conclusion') }
		</div>
		);
	}
}

export default Intro;



// WEBPACK FOOTER //
// ./src/Intro.jsx